import { guardClient } from '../_axios'

export type FocusDealPayload = {
  title: string
  content?: string
  expectedSales?: string
  expectedProfit?: string
  jobType: 'RA' | 'CA'
  companyId: number
}

export const insertFocusDeal = async (payload: FocusDealPayload) => {
  const response = await guardClient.post('/focus-deals', payload)
  return response.data
}

export const updateFocusDeal = async (id: number, payload: FocusDealPayload) => {
  const response = await guardClient.put(`/focus-deals/${id}`, payload)
  return response.data
}

export const deleteFocusDeal = async (id: number) => {
  const response = await guardClient.delete(`/focus-deals/${id}`)
  return response.data
}
